export const statisticsLabels = ["Approval", "Influence", "Insightfulness", "Relevance", "Politeness"];

export const filterTags = [
  {id: 0, label: 'All'},
  {id: 1, label: 'News'},
  {id: 2, label: 'Politics'},
  {id: 3, label: 'Sports'},
  {id: 4, label: 'Fun'},
  {id: 5, label: 'Help'},
  // {id: 6, label: 'Following'},
  {id: 6, label: 'Monitoring'},  
]
